export enum CUSTOMER_BACK_OFFICE {
    /**
     * @value Platform settings
     */
    CUSTOMER_SETTINGS = 'ADMIN.NAV.CUSTOMER_SETTINGS',
    /**
     * @value Global administrators
     */
    GLOBAL_ADMINS = 'ADMIN.NAV.SUPER_ADMINS',
}
